import React, { useEffect, useMemo, useState } from 'react';
import styles from './Input.module.scss';
import Label from '../../label/Label';
import { useId } from 'react';
import { useBrandingContext } from 'app-context/BrandingsContext';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import debounce from 'lodash/debounce';

import toast from 'react-hot-toast';

const Input = ({
  label,
  placeholder,
  required,
  type,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  style,
  autoComplete,
  inputType,
  disabled,
  actionImg,
  inputClassname,
  maxLength,
  countSpaces = false,
  noSvg,
  inputContainerClassName,
  ...props
}) => {
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;
  const [inputValue, setInputValue] = useState(value);
  const [showPassword, setShowPassword] = useState(false);

  const id = useId();
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  const showMaxCharToast = useMemo(
    () =>
      debounce(
        () => {
          toast.error(
            'You reached the maximum number of characters you are allowed to write'
          );
        },
        2000,
        { leading: true, trailing: false }
      ),
    []
  );
  const handleChange = (event) => {
    const newValue = event.target.value;
    const nonSpaceChars = newValue.replace(/\s/g, '');
    const effectiveLength = countSpaces
      ? newValue.length
      : nonSpaceChars.length;

    if (!maxLength || effectiveLength <= maxLength) {
      setInputValue(newValue);
      onChange && onChange(event);
    } else {
      showMaxCharToast();
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const nonSpaceCount = String(inputValue ?? '').replace(/\s/g, '').length;
  const typedLength = countSpaces
    ? String(inputValue ?? '').length
    : nonSpaceCount;

  return (
    <div
      className={`${styles['input-container']} ${inputContainerClassName}`}
      style={style}
    >
      {label && <Label text={label} required={required} htmlFor={id} />}
      <div
        className={`${styles['input-wrapper']} ${
          error && touched ? styles['input-error'] : ''
        } ${inputClassname ?? ''}`}
      >
        <div className={`${styles['img-input-cont']}`}>
          {type && !noSvg ? <SvgWithBranding type={type} /> : null}

          <input
            id={id}
            name={name}
            type={
              inputType == 'password'
                ? showPassword
                  ? 'text'
                  : 'password'
                : inputType
            }
            className={styles.input}
            placeholder={placeholder}
            style={{
              color: page_TextColor,
            }}
            onChange={handleChange}
            onBlur={onBlur}
            value={inputValue}
            autoComplete={autoComplete}
            disabled={disabled}
            // maxLength={maxLength}
            {...props}
          />
        </div>
        {inputType == 'password' && (
          <SvgWithBranding
            type='eye-icon'
            className={styles.eye}
            onClick={togglePasswordVisibility}
          />
        )}
        {typeof maxLength === 'number' && (
          <div className={styles['char-counter']} aria-live='polite'>
            {typedLength}/{maxLength}
          </div>
        )}
        {actionImg ? actionImg : null}
      </div>
      {error && touched && (
        <div className={styles['error-message']}>{error}</div>
      )}
    </div>
  );
};

export default Input;
